import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from './components/button/button.component';
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDialogModule } from '@angular/material/dialog';
import { AddItemPopupComponent } from './components/popups/add-item-popup/add-item-popup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputComponent } from './components/input/input.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { SelectComponent } from './components/select/select.component';
import { NormalizePricePipe } from './pipes/normalize-price.pipe';
import { ContactComponent } from '@shared/components/contact/contact.component';
import { TransformLocationPipe } from './pipes/transformLocation/transform-location.pipe';
import { TextareaComponent } from './components/textarea/textarea.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { ItemColorPipe } from './pipes/itemColor/item-color.pipe';
import { MatBadgeModule } from '@angular/material/badge';
import { ConfirmationPopupComponent } from './components/popups/confirmation-popup/confirmation-popup.component';
import { SelectItemPopupComponent } from './components/popups/select-item-popup/select-item-popup.component';
import { UserComponent } from './components/user/user.component';
import { NotificationComponent } from '@shared/components/notification/notification.component';
import { TransformRegionPipe } from '@shared/pipes/transform-region/transform-region.pipe';
import { TransformContactMethodPipe } from './pipes/transform-contact-method/transform-contact-method.pipe';
import { IconComponent } from '@standalone/components/icon/icon.component';
import { RemainingTimePipe } from './pipes/remaining-time/remaining-time.pipe';
import { FilterComponent } from './components/filter/filter.component';
import { RadiobuttonComponent } from './components/radiobutton/radiobutton.component';
import { MoneyItemComponent } from '@shared/components/money-item/money-item.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ReasonPopupComponent } from '@shared/components/popups/reason-popup/reason-popup.component';
import { SelectTradeTypeComponent } from '@shared/components/popups/select-trade-type-popup/select-trade-type-popup.component';
import { DealTypeComponent } from '@standalone/components/deal-type/deal-type.component';
import { ExboItemComponent } from './components/exbo-item/exbo-item.component';
import { TradeItemComponent } from '@shared/components/trade-item/trade-item.component';
import { TimerComponent } from '@shared/components/timer/timer.component';
import { AuctionItemComponent } from '@shared/components/auction-item/auction-item.component';
import { ExboItemTooltipComponent } from '@shared/components/exbo_item-tooltip/exbo-item-tooltip.component';
import { TooltipContainerComponent } from '@shared/components/tooltip-container/tooltip-container.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { UnlinkContactErrorPopupComponent } from '@shared/components/popups/unlink-contact-error-popup/unlink-contact-error-popup.component';
import { AuctionItemTooltipComponent } from '@shared/components/exbo_item-tooltip/auction-item-tooltip/auction-item-tooltip.component';
import { FieldErrorComponent } from '@standalone/components/field-error/field-error.component';
import { ImageFallbackDirective } from '@standalone/directives/image-fallback.directive';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { DialogComponent } from '@standalone/components/dialog/dialog.component';

@NgModule({
  declarations: [
    ButtonComponent,
    StarRatingComponent,
    AddItemPopupComponent,
    InputComponent,
    CheckboxComponent,
    SelectComponent,
    NormalizePricePipe,
    ContactComponent,
    TransformLocationPipe,
    TextareaComponent,
    FileUploaderComponent,
    ItemColorPipe,
    ConfirmationPopupComponent,
    SelectItemPopupComponent,
    UserComponent,
    NotificationComponent,
    TransformRegionPipe,
    TransformContactMethodPipe,
    RemainingTimePipe,
    FilterComponent,
    RadiobuttonComponent,
    MoneyItemComponent,
    ReasonPopupComponent,
    SelectTradeTypeComponent,
    ExboItemComponent,
    TradeItemComponent,
    TimerComponent,
    AuctionItemComponent,
    ExboItemTooltipComponent,
    TooltipContainerComponent,
    TooltipDirective,
    UnlinkContactErrorPopupComponent,
    AuctionItemTooltipComponent,
  ],
  exports: [
    CommonModule,
    ButtonComponent,
    StarRatingComponent,
    NgSelectModule,
    MatDialogModule,
    CheckboxComponent,
    InputComponent,
    SelectComponent,
    NormalizePricePipe,
    ContactComponent,
    TextareaComponent,
    FileUploaderComponent,
    ItemColorPipe,
    UserComponent,
    NotificationComponent,
    TransformRegionPipe,
    TransformContactMethodPipe,
    IconComponent,
    RemainingTimePipe,
    FilterComponent,
    RadiobuttonComponent,
    MoneyItemComponent,
    ReasonPopupComponent,
    ExboItemComponent,
    TradeItemComponent,
    TimerComponent,
    AuctionItemComponent,
    ExboItemTooltipComponent,
    TooltipContainerComponent,
    TooltipDirective,
    UnlinkContactErrorPopupComponent,
    AuctionItemTooltipComponent,
  ],
  imports: [
    CommonModule,
    RouterLink,
    NgSelectModule,
    MatDialogModule,
    FormsModule,
    ReactiveFormsModule,
    MatBadgeModule,
    MatProgressBarModule,
    IconComponent,
    TranslocoPipe,
    DealTypeComponent,
    FieldErrorComponent,
    ImageFallbackDirective,
    MatMenu,
    MatMenuTrigger,
    DialogComponent,
  ],
})
export class SharedModule {}
